module.exports = __webpack_public_path__ + "static/02-063586e8200279a27ee8f304fcdcc0a6.jpg";